import BelieveReviewScreen from 'features/believe/application/ApplicationReviewingScreen/ApplicationReview';
import React from 'react';

export default function CardApplicationFailPage() {
  return <BelieveReviewScreen />;
}
